import { httpsCallable } from 'firebase/functions';
import { functions } from '@/lib/firebase';
import type { Advertiser } from '../../../shared/types/advertiser';

export interface SubmitAdvertiserApplicationInput {
  companyName: string;
  contactName: string;
  website?: string | null;
  phone?: string | null;
  notes?: string | null;
}

export interface SubmitAdvertiserApplicationResult {
  advertiserId: string;
  status: 'pending' | 'active' | 'paused' | 'suspended' | 'archived';
}

export async function submitAdvertiserApplication(input: SubmitAdvertiserApplicationInput) {
  const fn = httpsCallable<
    SubmitAdvertiserApplicationInput,
    SubmitAdvertiserApplicationResult
  >(functions, 'submitAdvertiserApplication');
  const { data } = await fn(input);
  return data;
}

export interface UpdateAdvertiserProfileInput {
  advertiserId: string;
  companyName: string;
  contactName: string;
  website?: string | null;
  phone?: string | null;
}

interface UpdateAdvertiserProfileResult {
  advertiser: Advertiser;
}

export async function updateAdvertiserProfile(input: UpdateAdvertiserProfileInput) {
  const fn = httpsCallable<
    UpdateAdvertiserProfileInput,
    UpdateAdvertiserProfileResult
  >(functions, 'updateAdvertiserProfile');
  const { data } = await fn(input);
  return data;
}
